import React from 'react'
import { ProjectStatus } from 'controllers/Project/ProjectStateMachine'
import {
  useSalesLeadTimeData,
  GetSalesLeadTimeData,
} from './useSalesLeadTimeData'
import { DashboardWidget, KPITargetConfiguration } from '../DashboardWidget'
import { SalesLeadTimeGraph } from '../SalesLeadTimeGraph'
import { KpiFiltersAndTargetConfiguration as KpiDateAndTargetConfiguration } from '../KpiFiltersAndTargetConfiguration'
import { LocalizedListItemText } from 'components/Localization/LocalizedListItemText'
import { KPI } from 'controllers/Analytics/SalesLeadTimeController'
import { useTranslation } from 'react-i18next'

export const SalesLeadTimeWidget = (
  props: KPITargetConfiguration & {
    onError: (kpi: KPI, message: string) => void
  }
) => {
  const {
    controller,
    loading,
    salesGraphData,
    onSaveConfiguration,
    onSaveTarget,
  } = useSalesLeadTimeData(
    ProjectStatus[ProjectStatus.REQUESTED],
    ProjectStatus[ProjectStatus.ORDERED],
    'sales-lead-time',
    props.value,
    props.unit,
    KPI.salesLeadtime,
    props.onError
  )
  const { t } = useTranslation('common')

  return (
    <>
      <DashboardWidget
        subtitle={
          <LocalizedListItemText
            primaryTranslationKey={'common:dashboard-sales-lead-time-title'}
            primaryTypographyProps={{
              variant: 'h5',
            }}
            secondaryTranslationKey={
              'common:dashboard-sales-lead-time-subtitle'
            }
          />
        }
        GraphComponent={<SalesLeadTimeGraph data={salesGraphData} />}
        ConfigurationComponent={
          <KpiDateAndTargetConfiguration
            targetValueLabel={t(
              'common:dashboard-sales-lead-time-target',
              'target lead time'
            )}
            configuration={controller.GetGraphConfiguration()}
            saveConfiguration={onSaveConfiguration}
            saveTarget={onSaveTarget}
          />
        }
        loading={salesGraphData === undefined || loading['get-sales-lead-time']}
        empty={
          salesGraphData !== undefined &&
          !Boolean(controller.SalesLeadTimeData?.length)
        }
        onRefresh={async () =>
          await GetSalesLeadTimeData(
            controller,
            ProjectStatus[ProjectStatus.REQUESTED],
            ProjectStatus[ProjectStatus.ORDERED]
          )
        }
      />
    </>
  )
}
